import { useCallback, useSyncExternalStore } from "react";

/** Guard globale: sotto i 768px la console non e' utilizzabile, si invita ad aprirla da desktop. */
const MOBILE_QUERY = "(max-width: 767px)";

export function useIsMobile(): boolean {
  const subscribe = useCallback((notify: () => void) => {
    const media = window.matchMedia(MOBILE_QUERY);
    media.addEventListener("change", notify);
    return () => media.removeEventListener("change", notify);
  }, []);
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false,
  );
}
